import { render, staticRenderFns } from "./ReturnSample.vue?vue&type=template&id=e198432c&"
import script from "./ReturnSample.vue?vue&type=script&lang=ts&"
export * from "./ReturnSample.vue?vue&type=script&lang=ts&"
import style0 from "./ReturnSample.vue?vue&type=style&index=0&id=e198432c&prod&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports